import { css, html } from "lit";
import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { updateCSSVariables } from "./utils.js";
import { breakpoints } from "../../../responsive/index.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let DsfGridCell = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_horizontal = "left";
    this.dsf_vertical = "top";
  }
  render() {
    updateCSSVariables(this);
    return html`<slot></slot>`;
  }
};
DsfGridCell.shadowRootOptions = {
  ...BaseComponent.shadowRootOptions,
  delegatesFocus: false
};
DsfGridCell.styles = [
  ...BaseComponent.styles,
  css`
      :host {
        display: flex;
        grid-column: span var(--dsf-grid-cell-cols-mobile);
        align-items: var(--dsf-grid-cell-vertical);
        justify-content: var(--dsf-grid-cell-horizontal);
        --dsf-grid-tablet: var(--dsf-breakpoint-tablet);
        --dsf-grid-desktop: var(--dsf-breakpoint-desktop);
      }

      @media only screen and (min-width: ${breakpoints.tablet}px) {
        :host {
          grid-column: span var(--dsf-grid-cell-cols-tablet);
        }
      }

      @media only screen and (min-width: ${breakpoints.desktop}px) {
        :host {
          grid-column: span var(--dsf-grid-cell-cols-desktop);
        }
      }
    `
];
__decorateClass([
  prop({ type: String })
], DsfGridCell.prototype, "dsf_cols", 2);
__decorateClass([
  prop({ type: String })
], DsfGridCell.prototype, "dsf_cols_tablet", 2);
__decorateClass([
  prop({ type: String })
], DsfGridCell.prototype, "dsf_cols_mobile", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfGridCell.prototype, "dsf_horizontal", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfGridCell.prototype, "dsf_vertical", 2);
DsfGridCell = __decorateClass([
  defineElement("dsf-grid-cell")
], DsfGridCell);
export {
  DsfGridCell
};
